'use client';

import { useEffect } from 'react';
import Script from 'next/script';
import { initializeAd } from '@/lib/adsense';

interface AAMInjectorProps {
  publisherId: string;
}

export default function AAMInjector({ publisherId }: AAMInjectorProps) {
  useEffect(() => {
    // Google AdSense 광고 초기화
    initializeAd();
  }, []);

  return (
    <Script
      async
      src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${publisherId}`}
      crossOrigin="anonymous"
      strategy="afterInteractive"
    />
  );
} 